﻿window.terrbalance = function () {

	var margin = { top: 40, right: 20, bottom: 150, left: 100 },
		width = 960 - margin.left - margin.right,
        height = 500 - margin.top - margin.bottom;

	const names = [
		{ code: 'ENES_220_MSK_GENERATION', n: 0 },
		{ code: 'ENES_220_MSK_SMEGNIE', n: 1 },
		{ code: 'ENES_220_MSK_SETI_330', n: 2 },
		{ code: 'ENES_220_MSK_POST_OT_330', n: 3 },
		{ code: 'ENES_220_MSK_RSK', n: 3 },
		{ code: 'ENES_220_MSK_PO_POTREB', n: 4 },
		{ code: 'ENES_220_MSK_NEREFORMIROVANNIE', n: 5 },
		{ code: 'ENES_220_MSK_ZARUBEGNIE', n: 6 },
		{ code: 'ENES_220_MSK_SN', n: 7 },
		{ code: 'ENES_220_MSK_HN', n: 8 },
		{ code: 'ENES_330_MSK_GENERATION', n: 0 },
		{ code: 'ENES_330_MSK_SMEGNIE', n: 1 },
		{ code: 'ENES_330_MSK_SETI_330', n: 2 },
		{ code: 'ENES_330_MSK_RSK', n: 3 },
		{ code: 'ENES_330_MSK_PO_POTREB', n: 4 },
		{ code: 'ENES_330_MSK_NEREFORMIROVANNIE', n: 5 },
		{ code: 'ENES_330_MSK_ZARUBEGNIE', n: 6 },
		{ code: 'ENES_330_MSK_SN', n: 7 },
		{ code: 'ENES_330_MSK_HN', n: 8 },
	];

	function xscale(xdata) {
		return d3.scaleLinear().domain([0, xdata.length]).range([0, width]);
	}

	function xlabels(xdata) {
		return xdata;
	}

	function xticks(xdata) {
        return xdata.length > 48 ? 35 : xdata.length;
    }

    function xtickvalues(xdata, k, scale) {
        var l = k ? xdata.length / k : xdata.length;
        var m = 96;
        var d = [...Array(xdata.length).keys()];
        if (l <= 50)
            m = 1;
        else if (l <= 100)
            m = 2;
        else if (l <= 200)
            m = 4;
        else if (l <= 400)
            m = 8;
        else if (l <= 800)
            m = 16;
        else if (l <= 1200)
            m = 24;
        else if (l <= 2400)
            m = 48;
        else
            m = Math.floor(l / 30 / 48) * 48;
        return d.filter(function (value, index, Arr) {
            if (scale && (scale(value) < 0 || scale(value) > width))
                return false;
            return index % m == 0;
        })
	}

	function yscale(data, maxfunc, minfunc) {
		var ymax = d3.max(data, maxfunc);
		var ymin = d3.min(data, minfunc);

		ymax = ymax + (ymax - ymin) * 0.1;
		ymin = ymin - (ymax - ymin) * 0.1;

		return d3.scaleLinear().domain([ymin, ymax]).range([height, 0]);
	}

    var rotateXAxis = function (xAxis) {
        xAxis.selectAll("text")
            .style("text-anchor", "end")
            .attr("dx", "-.8em")
            .attr("dy", "-.55em")
            .attr("transform", "rotate(-90)");
	}

    function initChart(id, x, y, labels) {
        d3.select("#" + id + " svg").remove();
        var svg = d3.select("#" + id).append("svg")
            .attr('class', 'chart')
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom);
        svg.append("rect")
            .attr("width", "100%")
            .attr("height", "100%")
            .attr("fill", "white")
            .attr("id", "chartRect1");
        svg = svg.append("g")
			.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

		svg.append("rect")
			.attr("width", "100%")
			.attr("height", "100%")
            .attr("fill", "white")
            .attr("id", "chartRect2");

        var xGrid = svg.append("g").attr("clip-path", "url(#clip)").call(d3.axisBottom().tickFormat("").tickSize(height).tickValues(xtickvalues(labels)).scale(x));
        var yGrid = svg.append("g").call(d3.axisLeft().tickFormat("").tickSize(-width).ticks(20).scale(y));
        
        xGrid.selectAll("line").attr("stroke", "#ddd").attr("stroke-dasharray", "2,2");
        xGrid.selectAll("path").attr("opacity", 0);
        yGrid.selectAll("line").attr("stroke", "#ddd").attr("stroke-dasharray", "2,2");

        var xOffset = labels.length === 1 ? width / 2 : 0;
        var xAxis = svg.append("g")
            //.attr("clip-path", "url(#clip2)")
            .attr("transform", "translate(" + xOffset + "," + height + ")")
            .call(d3.axisBottom(x).tickValues(xtickvalues(labels)).tickFormat(function (d) {
				return labels[d];
			}));
        
        if (labels.length > 1)
            rotateXAxis(xAxis);

        var yAxis = svg.append("g").call(d3.axisLeft(y).ticks(20));

		var group = svg.append("g").attr("clip-path", "url(#clip)");

		svg.append("defs").append("clipPath")
			.attr("id", "clip")
			.append("rect")
			.attr("id", "clip-rect")
			.attr('stroke', 'red')
			.attr("width", width)
			.attr("height", height);
        svg.append("defs").append("clipPath")
            .attr("id", "clip2")
            .append("rect")
            .attr("id", "clip-rect")
            .attr('x', -10)
            .attr("width", width)
            .attr("height", height);

		var chart = { svg: svg, xAxis: xAxis, yAxis: yAxis, xGrid: xGrid, yGrid: yGrid, group: group };
        
		return chart;
	}
    
	function getDataFromTable (i, el) {
		const v = el.getAttribute('data-raw');
		if (!v) return null;
		return parseFloat(v);
    }

	// A function that updates the chart when the user zoom and thus new boundaries are available
    function updateChart(chart, x, y, labels, round) {
        // recover the new scale
        var newX = d3.event.transform.rescaleX(x);
        var newY = d3.event.transform.rescaleY(y);

        // update axes with these new boundaries
        chart.xAxis.call(d3.axisBottom(newX).tickValues(xtickvalues(labels)).tickFormat(function (d) { return labels[d]; }));
        if (labels.length > 1)
            rotateXAxis(chart.xAxis);

        chart.yAxis.call(d3.axisLeft(newY).ticks(20));

        chart.yGrid.call(d3.axisLeft().tickFormat("").tickSize(-width).ticks(20).scale(newY));
        chart.yGrid.selectAll("line").attr("stroke", "#ddd").attr("stroke-dasharray", "2,2");

        chart.xGrid.call(d3.axisBottom().tickFormat("").tickSize(height).tickValues(xtickvalues(labels)).scale(newX));
        chart.xGrid.selectAll("line").attr("stroke", "#ddd").attr("stroke-dasharray", "2,2");

        var vLine = d3.line()
            .x(function (d, i) { return newX(i); })
            .y(function (d) { return newY(round ? d | 0 : d); });

        chart.svg.selectAll(".dataline").attr("d", function (d) { return vLine(d.values); });

        for (var i = 0; i < 10; i++) {
            chart.svg.selectAll("#dots" + i).selectAll("circle")
                .attr("cx", function (d, i) { return newX(i); })
                .attr("cy", function (d) { return newY(round ? d | 0 : d); });
            chart.svg.selectAll("#dots_" + i).selectAll("circle")
                .attr("cx", function (d, i) { return newX(i); })
                .attr("cy", function (d) { return newY(round ? d | 0 : d); });
            chart.svg.selectAll("#dots_nc_" + i).selectAll("rect")
                .attr("x", function (d, i) { return newX(i) - 3; })
                .attr("y", function (d) { return newY(round ? d | 0 : d) - 3; });
            chart.svg.selectAll("#dots_ic_" + i).selectAll("rect")
                .attr("x", function (d, i) { return newX(i) - 3; })
                .attr("y", function (d) { return newY(round ? d | 0 : d) - 3; });
        }
    }

    // A function that updates the chart when the user zoom and thus new boundaries are available
    function updateChartOnClick(chart, newX, newY, labels, round) {

        chart.xAxis.call(d3.axisBottom(newX).ticks(xticks(labels), "f").tickFormat(function (d) { return labels[d]; }));
        if (labels.length > 1)
            rotateXAxis(xAxis);

        chart.yAxis.call(d3.axisLeft(newY));

        chart.yGrid.call(d3.axisLeft().tickFormat("").tickSize(-width).scale(newY));
        chart.yGrid.selectAll("line").attr("stroke", "#ddd").attr("stroke-dasharray", "2,2");

        chart.xGrid.call(d3.axisBottom().tickFormat("").tickSize(height).ticks(xticks(labels), "f").scale(newX));
        chart.xGrid.selectAll("line").attr("stroke", "#ddd").attr("stroke-dasharray", "2,2");

        var vLine = d3.line()
            .x(function (d, i) { return newX(i); })
            .y(function (d) { return newY(round ? d | 0 : d); });

        chart.svg.selectAll(".dataline").attr("d", function (d) { return vLine(d.values); });

        for (var i = 0; i < 10;i++)
            chart.svg.selectAll("#dots" + i).selectAll("circle")
                .attr("cx", function (d, i) { return newX(i); })
                .attr("cy", function (d) { return newY(round ? d | 0 : d); });        
    }

    function callout(g, value) {
        if (!value) return g.style("display", "none");

        g
            .style("display", null)
            .style("pointer-events", "none")
            .style("font", "10px sans-serif");

        const path = g.selectAll("path")
            .data([null])
            .join("path")
            .attr("fill", "white")
            .attr("stroke", "black");

        const text = g.selectAll("text")
            .data([null])
            .join("text")
            .call(function (text) {
                text
                    .selectAll("tspan")
                    .data((value + "").split(/\n/))
                    .join("tspan")
                    .attr("x", 0)
                    .attr("y", function (d, i) { return (i * 1.1).toString() + 'em'; })
                    .style("font-weight", function (_, i) { return i ? null : "bold"; })
                    .text(function (d) { return d; });
            });

        var bb = text.node().getBBox();
        g.attr("w", bb.width / 2);

        text.attr("transform", 'translate(' + (-bb.width / 2).toString() + ',' + (15 - bb.y).toString() + ')');
        path.attr("d", 'M' + (-bb.width / 2 - 10).toString() + ',5H-5l5,-5l5,5H' + (bb.width / 2 + 10).toString() + 'v' + (bb.height + 20).toString() + 'h-' + (bb.width + 20).toString() + 'z');
    }

	var instance = {

        loadDataInfo: function (sec, ydata, titles) {
            for (var j = 0; j < names.length; j++) {
                const name = names[j];
                const els = $(".reporttable .y-axis-" + name.code + " td");
                if (els.length > 0) {
                        ydata[name.n] = els.map(getDataFromTable).get();
                        titles[name.n] = els[0].innerText;
                        sec[name.n] = true;
                }
            }
        },

        loadDataInfo_PS: function (sec, ydata, titles, ncicData) {
            for (var j = 0; j <= 1; j++) {
                ydata[j] = document.querySelector("input[name='yaxis" + (j + 1).toString() + "dataraw']").value.split(",");
                if (j == 1)
                    ydata[j + 1] = document.querySelector("input[name='yaxis" + (j + 1).toString() + "dataraw']").value.split(",").map(v => -v);
                sec[j] = true;
                if (j === 0) {
                    ncicData[0] = document.querySelector("input[name='yaxis" + (j + 1).toString() + "datanc']").value.split(",");
                    ncicData[1] = document.querySelector("input[name='yaxis" + (j + 1).toString() + "dataic']").value.split(",");
                }
            }
            titles[0] = 'Фактический небаланс';
            titles[1] = 'Допустимый небаланс\n(по модулю)';
            titles[2] = 'Допустимый небаланс\n(зеркальное отображение\nв отрицательной плоскости)';
        },

        loadDataSeries: function (sec, data, xdata, ydata, titles) {
            for (var j = 0; j < sec.length; j++) {
                if (sec[j]) {
                    var datai = [];
                    for (var i = 0; i < xdata.length; i++) {
                        datai.push(ydata[j][i]);
                    }
                    data.series.push({ num: j, isScale: true, name: titles[j], values: datai });
                }
            }
        },

        chart220330: function () {

            const skipCols = 6;

			var xdata = $(".reporttable .x-axis td").map(function (i, el) { return i < skipCols ? null : el.innerText; }).get();
            
            // какие разделы показываются
            var sec = [false, false, false, false, false, false, false, false, false, true];
			// цвета разделов
			var colors = ['#ee82ee', '#4b0082', '#0000ff', '#008000', '#ff71a5', '#ffa500', '#ff0000', '#2d6b6d', '#0ecfa1', '#000000'];
			var ydata = [[], [], [], [], [], [], [], [], [], []];
			var titles = new Array(10);

            this.loadDataInfo(sec, ydata, titles);

			const elsAll = $(".reporttable .y-axis-all td");
			titles[9] = elsAll[0].innerText;
			ydata[9] = elsAll.map(getDataFromTable).get();

            //num - номер раздела, isScale: участвует в расчете по y
            //time - шкала времени, series - массив данных
			var data = { num : -1, isScaleY: false, time: xdata, series: [] };

            this.loadDataSeries(sec, data, xdata, ydata, titles);
            data.series[2].isScale = false;
			
			if (data.series.length > 2)
				margin.top += (data.series.length - 2) * 15;

            var labels = xlabels(xdata);

            var maxfunc = function (d) {
                if (d.isScale)
                    return Math.max.apply(null, d.values);
            };
            var minfunc = function (d) {
                if (d.isScale)
                    return Math.min.apply(null, d.values);
            };

            var x = xscale(xdata);
            var y = yscale(data.series, maxfunc, minfunc);

            var chart = initChart("terrbalance_chart", x, y, labels);

			var vLine = d3.line()
				.x(function (d, i) { return x(i); })
				.y(function (d) { return y(d | 0); });

			var idx = 0;
			for (var i = 0; i < sec.length; i++) {
				if (!sec[i]) continue;

				chart.group.append("path")
				.attr("id", "line" + i)
				.attr("active", "1")
				.attr("fill", "none")
				.attr("stroke", colors[i])
				.attr('class', 'dataline')
				.data([data.series[idx]])
				.attr("d", function (d) {
					return vLine(d.values);
				});

				idx++;
			}

			var svg = d3.select("svg.chart");

            idx = 0;
			for (var i = 0; i < sec.length; i++) {
				if (!sec[i]) continue;

                svg.append("text")
                    .attr("id", "text" + i)
                    .attr("x", margin.left)
                    .attr("y", 15 + idx * 15)
                    .attr("line", i)
                    .style("fill", colors[i])
                    .style("font-size", "12px")
                    .style("font-weight", "normal")
                    .style("cursor", "pointer")
                    .text(titles[i])
                    .on("click", function () {
                        var n = this.getAttribute('line');
                        var line = d3.select("#line" + n);
                        var newOpacity = line.attr("active") == '1' ? 0 : 1;
                        var isView = newOpacity == 0 ? false : true;
                        sec[n] = isView;
                        line.style("opacity", newOpacity);
                        line.attr("active", newOpacity);
                        d3.select("#text" + n).style('fill', newOpacity == 0 ? '#ccc' : colors[n]);

                        for (var p = 0; p < data.series.length; p++) {
                            if (data.series[p].num == n)
                                data.series[p].isScale = isView;
                        }
                        x = xscale(xdata);
                        y = yscale(data.series, maxfunc, minfunc);

                        updateChartOnClick(chart, x, y, labels, true);

                    });

				idx++;
			}

			// Set the zoom and Pan features: how much you can zoom, on which part, and what to do when there is a zoom
            var zoom = d3.zoom()
                .scaleExtent([.5, 20])  // This control how much you can unzoom (x0.5) and zoom (x20)
                .extent([[margin.left, margin.top], [width, height]])
                .translateExtent([[margin.left, margin.top], [width, height]])
                .on("zoom", function () { updateChart(chart, x, y, labels, true); });

            svg.call(zoom);
		},

        chartEnes: function () {
    		const skipCols = 6;

    		var xdata = $(".reporttable .x-axis td").map(function (i, el) { return i < skipCols ? null : el.innerText; }).get();
    		var ydata = $(".reporttable .y-axis td").map(function (i, el) {
    			if (i < skipCols - 2) return null;
    			const n = parseFloat(el.getAttribute('data-raw'));
    			return n;
    		}).get();

    		var datai = [];
    		for (var i = 0; i < xdata.length; i++)
    			datai.push(ydata[i]);
    		var data = { name: '', values: datai};

    		var labels = xlabels(xdata);
    		var x = xscale(xdata);
    		var func = function (d) { return d; };
    		var y = yscale(data.values, func, func);

            var chart = initChart("terrbalance_chart", x, y, labels);

    		var vLine = d3.line()
				.x(function (d, i) { return x(i); })
				.y(function (d) { return y(d | 0); });

    		chart.group.append("path")
				.style("fill", "none")
				.style("stroke", "#000")
				.attr('class', 'dataline')
				.data([data])
				.attr("d", function (d) {
					return vLine(d.values);
				});

			var svg = d3.select("svg.chart");
    		svg.append("text")
				.attr("x", margin.left)
				.attr("y", 25)
				.style("fill", "#000")
				.style("font-size", "12px")
				.style("font-weight", "normal")
				.text("Потери электроэнергии в сети ЕНЭС в зоне обслуживания МЭС");

    		// Set the zoom and Pan features: how much you can zoom, on which part, and what to do when there is a zoom
    		var zoom = d3.zoom()
				.scaleExtent([.5, 20])  // This control how much you can unzoom (x0.5) and zoom (x20)
				.extent([[margin.left, margin.top], [width, height]])
				.translateExtent([[margin.left, margin.top], [width, height]])
				.on("zoom", function () { updateChart(chart, x, y, labels, true); });

    		svg.call(zoom);
    	},

        chartPS: function (args) {
            var xdata = document.querySelector("input[name='x-axis']").value.split(";");
            width = window.$("body").width() - 120;
            height = width / 2.5;
            margin = { top: 80, right: 20, bottom: 150, left: 50 };
            
            // какие разделы показываются
            var sec = [true, true, false];
            var show_ic = true;
            var show_nc = true;
            var show_upperSetPoint = true;
            var show_lowerSetPoint = true;
            var show_maxmin = true;
            // цвета разделов
            var colors = ['#06C270', '#FA564C', '#FA564C'];
            var ydata = [[], [], []];
            var ncicData = [[], []];
            var titles = new Array(3);

            this.loadDataInfo_PS(sec, ydata, titles, ncicData);

            //num - номер раздела, isScale: участвует в расчете по y
            //time - шкала времени, series - массив данных
            var data = { num: -1, isScaleY: false, time: xdata, series: [] };

            this.loadDataSeries(sec, data, xdata, ydata, titles);

            if (data.series.length > 2)
                margin.top += (data.series.length - 2) * 15;

            var labels = xlabels(xdata);

            var maxfunc = function (d) {
                var hl = show_upperSetPoint && args.highlimit != null ? args.highlimit : null;
                var ll = show_lowerSetPoint && args.lowerlimit != null ? args.lowerlimit : null;
                if (d.isScale)
                    return Math.max(Math.max.apply(null, d.values), hl, ll);
            };
            var minfunc = function (d) {
                var hl = show_upperSetPoint && args.highlimit != null ? args.highlimit : null;
                var ll = show_lowerSetPoint && args.lowerlimit != null ? args.lowerlimit : null;
                if (d.isScale)
                    return Math.min(Math.min.apply(null, d.values), hl, ll);
            };

            var x = xscale(xdata);
            var y = yscale(data.series, maxfunc, minfunc);

            rotateXAxis = function (xAxis) {
                xAxis.selectAll("text")
                    .style("text-anchor", "end")
                    .attr("dx", "-.7em")
                    .attr("dy", "-.35em")
                    .attr("transform", "rotate(-90)");
            }

            var chart = initChart("balanceps_chart", x, y, labels);
            chart.xGrid.selectAll("path").remove();
            chart.xGrid.selectAll("line").attr("stroke-dasharray", null);
            chart.yGrid.selectAll("path").remove();
            chart.yGrid.selectAll("line").attr("stroke-dasharray", null);
            chart.xAxis.selectAll("path").attr("stroke-width", "2");
            chart.yAxis.selectAll("path").attr("stroke-width", "2");

            chart.xAxis.attr("font-size", '14px');
            chart.xAxis.attr("font-weight", '500');
            chart.xAxis.attr("font-family", 'Roboto');
            chart.yAxis.attr("font-size", '14px');
            chart.yAxis.attr("font-weight", '500');
            chart.yAxis.attr("font-family", 'Roboto');

            chart.svg.append("text")
                .attr("x", 10)
                .attr("y", 16)
                .style("font-size", "14px")
                .style("font-weight", "bold")
                .style("font-family", 'Roboto')
                .style("fill", '#666')
                .text("%");
            chart.svg.append("text")
                .attr("x", width - 60)
                .attr("y", height - 10)
                .style("font-size", "14px")
                .style("font-weight", "bold")
                .style("font-family", 'Roboto')
                .style("fill", '#666')
                .text("Период");

            var LastIndex = 0;
            var PrevXPos = 0;
            var PrevYValue = 0;
            var Delta = 15;
            const xDelta = 10;

            var points = [];
            var cxy_x = x;
            var cxy_y = y;
            var cx = function (d, i) {
                var xi = cxy_x(i);
                if (i == 0) {
                    PrevXPos = xi;
                }
                if (xi - PrevXPos < xDelta) {
                    var delta = Math.abs(cxy_y(d) - PrevYValue);
                    if (delta < Delta) {
                        xi = PrevXPos;
                    }
                    else {
                        LastIndex = i;
                    }
                }
                else
                    LastIndex = i;
                PrevXPos = xi;
                return xi;
            };
            var cy = function (d, i) {
                var yi = cxy_y(d);
                if (i == 0) {
                    PrevYValue = yi;
                }
                else if (LastIndex < i)
                    yi = PrevYValue;

                PrevYValue = yi;
                points.push([PrevXPos, PrevYValue, LastIndex]);
                return yi;
            };

            var vLine = d3.line()
                .x(cx)
                .y(cy);
            //var vArea = d3.area()
            //    .x(function (d, i) { return x(i); })
            //    .y0(function (d) { return y(d); }).
            //    y1(function (d) { return y(-d); });

            for (var i = 0; i < sec.length; i++) {
                if (!sec[i]) continue;

                if (labels.length === 1)
                    chart.group.append("g")
                        .attr("id", "point" + i)
                        .attr("active", "1")
                        .attr("stroke", colors[i])
                        .attr("stroke-width", 2.5)
                        .attr("fill", colors[i])
                        .selectAll("circle")
                        .data([data.series[i]])
                        .join("circle")
                        .attr("cx", function (d) { return width / 2; })
                        .attr("cy", function (d) {
                            return y(d.values[0]);
                        })
                        .attr("r", 4);
                else {
                    //if (i === 0)
                    points = [];
                    chart.group.append("path")
                        .attr("id", "line" + i)
                        .attr("active", "1")
                        .attr("fill", "none")
                        .attr("stroke", colors[i])
                        .attr("stroke-width", 1.5)
                        .attr('class', 'dataline')
                        .data([data.series[i]])
                        .attr("d", function (d) {
                            return vLine(d.values);
                        });
                    chart.group.append("g")
                        .attr("id", "dots" + i)
                        .attr('class', 'dots')
                        .attr("stroke", colors[i])
                        .attr("fill", colors[i])
                        .attr("stroke-width", 1)
                        .selectAll("circle")
                        .data(data.series[i].values)
                        .join("circle")
                        .attr("cx", function (d, i) { return points[i][0].toFixed(); })
                        .attr("cy", function (d, i) { return points[i][1].toFixed(); })
                        .attr("xlabel", function (d, i) { return labels[points[i][2]]; })
                        .attr("name", titles[i])
                        //.attr("opacity", "0")
                        .attr("r", 2);
                    chart.group.append("g")
                        .attr("id", "dots_" + i)
                        .attr('class', 'dots')
                        .attr("stroke", "#222")
                        .attr("fill", "transparent")
                        .attr("stroke-width", 0.7)
                        .selectAll("circle")
                        .data(data.series[i].values)
                        .join("circle")
                        .attr("cx", function (d, i) { return points[i][0].toFixed(); })
                        .attr("cy", function (d, i) { return points[i][1].toFixed(); })
                        .attr("xlabel", function (d, i) { return labels[points[i][2]]; })
                        .attr("name", titles[i])
                        .attr("opacity", function (d, i) { return i > 0 && points[i][0].toFixed() == points[i - 1][0].toFixed() && points[i][1].toFixed() == points[i - 1][1].toFixed() ? 0 : 1; })
                        .attr("r", 2.5);
                    chart.group.append("g")
                        .attr("id", "dots_ic_" + i)
                        .attr('class', 'dots')
                        .attr("stroke", "red")
                        .attr("stroke-width", 1)
                        .attr("fill", "transparent")
                        //.selectAll("rect")
                        //.data(data.series[i].values)
                        //.join("rect")
                        //.attr("x", function (d, i) { return points[i][0] - 3; })
                        //.attr("y", function (d, i) { return points[i][1] - 3; })
                        //.attr("xlabel", function (d, i) { return labels[i] + "\nНет данных"; })
                        //.attr("name", titles[i])
                        //.attr("visibility", function (d, i) { return ncicData[1][i] === "1" ? "visible" : "hidden"; })
                        //.attr("width", 6)
                        //.attr("height", 6);
                        .selectAll("circle")
                        .data(data.series[i].values)
                        .join("circle")
                        .attr("cx", function (d, i) { return points[i][0]; })
                        .attr("cy", function (d, i) { return points[i][1]; })
                        .attr("xlabel", function (d, i) { return labels[points[i][2]] + "\nНет данных"; })
                        .attr("name", titles[i])
                        .attr("visibility", function (d, i) { return ncicData[1][i] === "1" ? "visible" : "hidden"; })
                        .attr("r", 5);
                    chart.group.append("g")
                        .attr("id", "dots_nc_" + i)
                        .attr('class', 'dots')
                        .attr("stroke", "#FFD800")
                        .attr("stroke-width", 1)
                        .attr("fill", "transparent")
                        //.selectAll("rect")
                        //.data(data.series[i].values)
                        //.join("rect")
                        //.attr("x", function (d, i) { return points[i][0] - 3; })
                        //.attr("y", function (d, i) { return points[i][1] - 3; })
                        //.attr("xlabel", function (d, i) { return labels[i] + "\nНекоммерческий статус"; })
                        //.attr("name", titles[i])
                        //.attr("visibility", function (d, i) { return ncicData[0][i] === "1" ? "visible" : "hidden"; })
                        //.attr("width", 6)
                        //.attr("height", 6);
                        .selectAll("circle")
                        .data(data.series[i].values)
                        .join("circle")
                        .attr("cx", function (d, i) { return points[i][0]; })
                        .attr("cy", function (d, i) { return points[i][1]; })
                        .attr("xlabel", function (d, i) { return labels[points[i][2]] + "\nНекоммерческий статус"; })
                        .attr("name", titles[i])
                        .attr("visibility", function (d, i) { return ncicData[0][i] === "1" ? "visible" : "hidden"; })
                        .attr("r", 5);
                    //if (i === 1)
                    //    chart.group.append("path")
                    //        .attr("id", "line" + i)
                    //        .attr("active", "1")
                    //        .attr("fill", "#A8DDFF")
                    //        .attr("stroke", colors[1])
                    //        .data([data.series[1]])
                    //        .attr("d", function (d) {
                    //            return vArea(d.values);
                    //        });
                }
            }
            if (args.highlimit != null)
                chart.group.append("line")
                    .attr("id", "upperSetPoint")
                    .attr("stroke", "#FF9090")
                    .attr("stroke-width", 1.5)
                    .attr("x1", cxy_x(0))
                    .attr("y1", cxy_y(args.highlimit))
                    .attr("x2", cxy_x(xdata.length - 1))
                    .attr("y2", cxy_y(args.highlimit));
            if (args.lowerlimit != null)
                chart.group.append("line")
                    .attr("id", "lowerSetPoint")
                    .attr("stroke", "#28EADF")
                    .attr("stroke-width", 1.5)
                    .attr("x1", cxy_x(0))
                    .attr("y1", cxy_y(args.lowerlimit))
                    .attr("x2", cxy_x(xdata.length - 1))
                    .attr("y2", cxy_y(args.lowerlimit));
            /*var m1 = d3.max(data.series[1].values.map(s => parseFloat(s)));
            chart.group.append("line")
                .attr("id", "lineMax")
                .attr("stroke", "#FFC658")
                .attr("stroke-width", 1.5)
                .attr("x1", cxy_x(0))
                .attr("y1", cxy_y(m1))
                .attr("x2", cxy_x(xdata.length - 1))
                .attr("y2", cxy_y(m1));
            chart.group.append("line")
                .attr("id", "lineMin")
                .attr("stroke", "#FFC658")
                .attr("stroke-width", 1.5)
                .attr("x1", cxy_x(0))
                .attr("y1", cxy_y(d3.min(data.series[2].values.map(s => parseFloat(s)))))
                .attr("x2", cxy_x(xdata.length - 1))
                .attr("y2", cxy_y(d3.min(data.series[2].values.map(s => parseFloat(s)))));*/

            var svg = d3.select("svg.chart");

            var renderCheckMark = function (gr, id, color) {
                gr.append('path')
                    .attr('d', "M25.333 6.66699V25.334H6.66602V6.66699H25.333Z")
                    .attr("fill", "white")
                    .attr("transform", "scale(0.667)");
                gr.append('path')
                    .attr('d', "M13.333 22.667L6.66602 16L8.54602 14.107L13.333 18.894L23.453 8.774L25.333 10.667L13.333 22.667ZM25.333 4H6.66602C5.18602 4 3.99902 5.187 3.99902 6.667V25.334C3.99902 26.807 5.19302 28.001 6.66602 28.001H25.333C26.806 28.001 28 26.807 28 25.334V6.667C28 5.187 26.8 4 25.333 4V4Z")
                    .attr("fill", color)
                    .attr("transform", "scale(0.667)");
                gr.append('path')
                    .attr('d', "M25.333 6.66699V25.334H6.66602V6.66699H25.333Z")
                    .attr("fill", "white")
                    .attr("transform", "scale(0.667)")
                    .attr("opacity", 0)
                    .attr("id", id);
			}

            var display_ic = function (dots_ic_num) {
                var dots_ic = d3.select("#dots_ic_" + dots_ic_num);
                if (sec[dots_ic_num] && btnPoints.classList.contains("btnchecked") && show_ic) {
                    dots_ic.style("opacity", "1");
                }
                if (!sec[dots_ic_num] || !btnPoints.classList.contains("btnchecked") || !show_ic) {
                    dots_ic.style("opacity", "0");
                }
            }

            var display_nc = function (dots_nc_num) {
                var dots_nc = d3.select("#dots_nc_" + dots_nc_num);
                if (sec[dots_nc_num] && btnPoints.classList.contains("btnchecked") && show_nc) {
                    dots_nc.style("opacity", "1");
                }
                if (!sec[dots_nc_num] || !btnPoints.classList.contains("btnchecked") || !show_nc) {
                    dots_nc.style("opacity", "0");
                }
            }

            var seriesTitle = function (xPosition, yPosition, i) {
                var g = svg.append("g").attr("transform", "translate(" + xPosition + "," + yPosition + ")")
                    .style("cursor", "pointer")
                    .attr("line", i);
                renderCheckMark(g, "checkMark" + i, colors[i]);
                g.append('line')
                    .attr('x1', 26)
                    .attr('y1', 12)
                    .attr('x2', 42)
                    .attr('y2', 12)
                    .attr("stroke", colors[i]);
                g.append("circle")
                    .attr("stroke", "black")
                    .attr("fill", "white")
                    .attr("stroke-width", 1.5)
                    .attr("cx", 34)
                    .attr("cy", 12)
                    .attr("r", 2);

                titles[i].split('\n').forEach(function (text, index) {
                    g.append("text")
                        .attr("x", 50)
                        .attr("y", 16 + index * 16)
                        .style("font-size", "12px")
                        .style("font-weight", "normal")
                        .text(text);
                });
                
                g.on("click", function () {
                    var btnPoints = document.getElementById("btnPoints");
                    var n = i;// this.getAttribute('line');
                    if (labels.length === 1) {
                        var point = d3.select("#point" + n);
                        var cm = d3.select("#checkMark" + n);
                        var newOpacity = point.attr("active") === '1' ? 0 : 1;
                        var isView = newOpacity === 0 ? false : true;
                        sec[n] = isView;
                        point.style("opacity", newOpacity);
                        cm.style("opacity", newOpacity === 0 ? 1 : 0);
                        point.attr("active", newOpacity);
                    }
                    else {
                        var line = d3.select("#line" + n);
                        var dots = d3.select("#dots" + n);
                        var dots_ = d3.select("#dots_" + n);
                        var cm = d3.select("#checkMark" + n);
                        var newOpacity = line.attr("active") === '1' ? 0 : 1;
                        var isView = newOpacity === 0 ? false : true;
                        sec[n] = isView;
                        line.style("opacity", newOpacity);
                        cm.style("opacity", newOpacity === 0 ? 1 : 0);
                        line.attr("active", newOpacity);
                        if (btnPoints != null && !btnPoints.classList.contains("btnchecked"))
                            newOpacity = 0;
                        dots.style("opacity", newOpacity);
                        dots.attr("active", newOpacity);
                        dots_.style("opacity", newOpacity);
                        display_ic(n);
                        display_nc(n);
                    }
                    data.series[i].isScale = isView;

                    y = yscale(data.series, maxfunc, minfunc);
                    zoom.scaleBy(svg.transition().duration(1000), 1);
                });
                return g;
			}

            seriesTitle(250, 5, 0);
            seriesTitle(450, 5, 1);
            //var g2 = seriesTitle(450, 45, 2);

            if (labels.length > 1) {
                var g = svg.append("g").attr("transform", "translate(680,5)");//.style("cursor", "pointer");
                //renderCheckMark(g, "checkMarkNoData", "#3C90F2");
                g.append("circle")
                    .attr("cx", 33)
                    .attr("cy", 12)
                    .attr("width", 6)
                    .attr("height", 6)
                    .attr("stroke", "red")
                    .attr("stroke-width", 2)
                    .attr("fill", "transparent")
                    .attr("r", "5");
                g.append("text")
                    .attr("x", 45)
                    .attr("y", 16)
                    .style("font-size", "12px")
                    .style("font-weight", "normal")
                    .text("Нет данных");
                /*g.on("click", function () {
                    show_ic = !show_ic;
                    for (var n = 0; n < sec.length; n++) {
                        var cm = d3.select("#checkMarkNoData");
                        cm.style("opacity", show_ic ? 0 : 1);
                        display_ic(n);
                    }
                });*/
                var g = svg.append("g").attr("transform", "translate(680,35)");//.style("cursor", "pointer");
                //renderCheckMark(g, "checkMarkNonCommercial", "#3C90F2");
                g.append("circle")
                    .attr("cx", 33)
                    .attr("cy", 12)
                    .attr("width", 6)
                    .attr("height", 6)
                    .attr("stroke", "#FFD800")
                    .attr("stroke-width", 2)
                    .attr("fill", "transparent")
                    .attr("r", "5");
                g.append("text")
                    .attr("x", 45)
                    .attr("y", 16)
                    .style("font-size", "12px")
                    .style("font-weight", "normal")
                    .text("Некоммерческий статус");
                /*g.on("click", function () {
                    show_nc = !show_nc;
                    for (var n = 0; n < sec.length; n++) {
                        var cm = d3.select("#checkMarkNonCommercial");
                        cm.style("opacity", show_nc ? 0 : 1);
                        display_nc(n);
                    }
                });*/

                if (args.highlimit != null) {
                    var g = svg.append("g").attr("transform", "translate(880,5)");//.style("cursor", "pointer");
                    //renderCheckMark(g, "checkMarkUpperSetpoint", "#3C90F2");
                    g.append("line")
                        .attr("x1", 30)
                        .attr("y1", 12)
                        .attr("x2", 55)
                        .attr("y2", 12)
                        .attr("stroke", "#FF9090")
                        .attr("stroke-width", 1.5);
                    g.append("text")
                        .attr("x", 65)
                        .attr("y", 16)
                        .style("font-size", "12px")
                        .style("font-weight", "normal")
                        .text("Верхняя уставка (" + args.highlimit + "%)");
                    /*g.on("click", function () {
                        show_upperSetPoint = !show_upperSetPoint;
                        var cm = d3.select("#checkMarkUpperSetpoint");
                        cm.style("opacity", show_upperSetPoint ? 0 : 1);
                        d3.select("#upperSetPoint").style("opacity", show_upperSetPoint ? 1 : 0);
                        y = yscale(data.series, maxfunc, minfunc);
                        zoom.scaleBy(svg.transition().duration(1000), 1);
                    });*/
                }

                if (args.lowerlimit != null) {
                    var g = svg.append("g").attr("transform", "translate(880,35)");//.style("cursor", "pointer");
                    //renderCheckMark(g, "checkMarkLowerSetpoint", "#3C90F2");
                    g.append("line")
                        .attr("x1", 30)
                        .attr("y1", 12)
                        .attr("x2", 55)
                        .attr("y2", 12)
                        .attr("stroke", "#28EADF")
                        .attr("stroke-width", 1.5);
                    g.append("text")
                        .attr("x", 65)
                        .attr("y", 16)
                        .style("font-size", "12px")
                        .style("font-weight", "normal")
                        .text("Нижняя уставка (" + args.lowerlimit + "%)");
                    /*g.on("click", function () {
                        show_lowerSetPoint = !show_lowerSetPoint;
                        var cm = d3.select("#checkMarkLowerSetpoint");
                        cm.style("opacity", show_lowerSetPoint ? 0 : 1);
                        d3.select("#lowerSetPoint").style("opacity", show_lowerSetPoint ? 1 : 0);
                        y = yscale(data.series, maxfunc, minfunc);
                        zoom.scaleBy(svg.transition().duration(1000), 1);
                    });*/
                }
                /*
                var g = svg.append("g").attr("transform", "translate(1080,5)").style("cursor", "pointer");
                renderCheckMark(g, "checkMarkMaxMin", "#3C90F2");
                g.append("line")
                    .attr("x1", 30)
                    .attr("y1", 12)
                    .attr("x2", 55)
                    .attr("y2", 12)
                    .attr("stroke", "#FFC658")
                    .attr("stroke-width", 1.5);
                "Максимальное/\nминимальное значение\nдопустимого небаланса\nза период построения\nграфика".split('\n').forEach(function (text, index) {
                    g.append("text")
                        .attr("x", 65)
                        .attr("y", 16 + index * 16)
                        .style("font-size", "12px")
                        .style("font-weight", "normal")
                        .text(text);
                });
                g.on("click", function () {
                    show_maxmin = !show_maxmin;
                    for (var n = 0; n < sec.length; n++) {
                        var cm = d3.select("#checkMarkMaxMin");
                        cm.style("opacity", show_maxmin ? 0 : 1);
                        d3.select("#lineMax").style("opacity", show_maxmin ? 1 : 0);
                        d3.select("#lineMin").style("opacity", show_maxmin ? 1 : 0);
                    }
                });*/
            }
            var zoom = {};
            if (labels.length > 1) {
                zoom = d3.zoom()
                    .scaleExtent([.8, 15])
                    .extent([[0, 0], [width, height]])
                    .translateExtent([[0, 0], [width, height]])
                    .filter(() => {
                        return d3.event.shiftKey;
                    })
                    .on("zoom", function () { /*updateChart(chart, x, y, labels, false);*/
                        var newX = d3.event.transform.rescaleX(x);
                        var newY = d3.event.transform.rescaleY(y);
                        chart.xAxis.call(d3.axisBottom(newX).tickValues(xtickvalues(labels, d3.event.transform.k, newX)).tickFormat(function (d) { return labels[d]; }));
                        chart.yAxis.call(d3.axisLeft(newY).ticks(20));
                        rotateXAxis(chart.xAxis);

                        chart.xGrid.call(d3.axisBottom().tickFormat("").tickSize(height).tickValues(xtickvalues(labels, d3.event.transform.k)).scale(newX));
                        chart.yGrid.call(d3.axisLeft().tickFormat("").tickSize(-width).ticks(20).scale(newY));
                        //chart.yGrid.call(d3.axisLeft().tickFormat("").tickSize(-width).scale(newY));
                        //chart.xGrid.call(d3.axisBottom().tickFormat("").tickSize(height).ticks(xticks(labels), "f").scale(newX));
                        //chart.xGrid.selectAll("path").remove();
                        chart.xGrid.selectAll("line").attr("stroke", "#ddd");
                        chart.xGrid.selectAll("path").attr("opacity", 0);
                        chart.yGrid.selectAll("line").attr("stroke", "#ddd");
                        //chart.yGrid.selectAll("path").remove();
                        //chart.yGrid.selectAll("line").attr("stroke-dasharray", null);
                        //chart.xAxis.selectAll("path").attr("stroke-width", "2");
                        //chart.yAxis.selectAll("path").attr("stroke-width", "2");

                        chart.xAxis.attr("font-size", '14px');
                        chart.xAxis.attr("font-weight", '500');
                        chart.xAxis.attr("font-family", 'Roboto');
                        chart.yAxis.attr("font-size", '14px');
                        chart.yAxis.attr("font-weight", '500');
                        chart.yAxis.attr("font-family", 'Roboto');

                        cxy_x = newX;
                        cxy_y = newY;
                        var vLine = d3.line()
                            .x(cx)
                            .y(cy);

                        for (var j = 0; j < sec.length; j++) {
                            points = [];
                            chart.svg.selectAll("#line" + j).attr("d", function (d) { return vLine(d.values); });

                            chart.svg.selectAll("#dots" + j).selectAll("circle")
                                .attr("cx", function (d, i) { return points[i][0].toFixed(); })
                                .attr("cy", function (d, i) { return points[i][1].toFixed(); })
                                .attr("xlabel", function (d, i) { return labels[points[i][2]]; });

                            chart.svg.selectAll("#dots_" + j).selectAll("circle")
                                .attr("opacity", function (d, i) { return i > 0 && points[i][0].toFixed() == points[i - 1][0].toFixed() && points[i][1].toFixed() == points[i - 1][1].toFixed() ? 0 : 1; })
                                .attr("cx", function (d, i) { return points[i][0].toFixed(); })
                                .attr("cy", function (d, i) { return points[i][1].toFixed(); })
                                .attr("xlabel", function (d, i) { return labels[points[i][2]]; });

                            chart.svg.selectAll("#dots_ic_" + j).selectAll("circle")
                                .attr("cx", function (d, i) { return points[i][0].toFixed(); })
                                .attr("cy", function (d, i) { return points[i][1].toFixed(); })
                                .attr("xlabel", function (d, i) { return labels[points[i][2]] + "\nНет данных"; });

                            chart.svg.selectAll("#dots_nc_" + j).selectAll("circle")
                                .attr("cx", function (d, i) { return points[i][0].toFixed(); })
                                .attr("cy", function (d, i) { return points[i][1].toFixed(); })
                                .attr("xlabel", function (d, i) { return labels[points[i][2]] + "\nНекоммерческий статус"; });
                        }

                        var k = d3.event.transform.k * 100;
                        document.getElementById("spanScale").innerHTML = "Масштаб: " + k.toFixed(0).toString() + "%";

                        if (args.highlimit != null)
                            chart.svg.selectAll("#upperSetPoint")
                                .attr("x1", cxy_x(0))
                                .attr("y1", cxy_y(args.highlimit))
                                .attr("x2", cxy_x(xdata.length - 1))
                                .attr("y2", cxy_y(args.highlimit));
                        if (args.lowerlimit != null)
                            chart.svg.selectAll("#lowerSetPoint")
                                .attr("x1", cxy_x(0))
                                .attr("y1", cxy_y(args.lowerlimit))
                                .attr("x2", cxy_x(xdata.length - 1))
                                .attr("y2", cxy_y(args.lowerlimit));
                        /*
                        chart.svg.selectAll("#lineMax")
                            .attr("x1", cxy_x(0))
                            .attr("y1", cxy_y(d3.max(data.series[1].values.map(s => parseFloat(s)))))
                            .attr("x2", cxy_x(xdata.length - 1))
                            .attr("y2", cxy_y(d3.max(data.series[1].values.map(s => parseFloat(s)))));
                        chart.svg.selectAll("#lineMin")
                            .attr("x1", cxy_x(0))
                            .attr("y1", cxy_y(d3.min(data.series[2].values.map(s => parseFloat(s)))))
                            .attr("x2", cxy_x(xdata.length - 1))
                            .attr("y2", cxy_y(d3.min(data.series[2].values.map(s => parseFloat(s)))));
                            */
                    });

                svg.call(zoom);
            }

            const tooltip = svg.append("g");

            var tt = function (c) {
                var m = d3.mouse(this);
                var tooltip_x = m[0] + margin.left;
                var w = parseFloat(tooltip.attr("w"));
                if (tooltip_x < w + 10)
                    tooltip_x = w + 10;
                if (tooltip_x + w/2 + 10 > width)
                    tooltip_x = width - w/2 + 10;
                tooltip
                    .attr("transform", 'translate(' + tooltip_x.toString() + ',' + (m[1] + margin.top).toString() + ')')
                    .call(callout, window.$(this).attr('name') + '\n' + window.$(this).attr('xlabel') + '\n' + c.toString() + "%");
            };
            var ttl = function () { tooltip.call(callout, null); };

            for (var i = 0; i < sec.length; i++) {
                svg.selectAll("#dots" + i + " circle").on("touchmove mousemove", tt);
                svg.selectAll("#dots" + i + " circle").on("touchend mouseleave", ttl);
                svg.selectAll("#dots_" + i + " circle").on("touchmove mousemove", tt);
                svg.selectAll("#dots_" + i + " circle").on("touchend mouseleave", ttl);
                svg.selectAll("#dots_ic_" + i + " circle").on("touchmove mousemove", tt);
                svg.selectAll("#dots_ic_" + i + " circle").on("touchend mouseleave", ttl);
                svg.selectAll("#dots_nc_" + i + " circle").on("touchmove mousemove", tt);
                svg.selectAll("#dots_nc_" + i + " circle").on("touchend mouseleave", ttl);
            }

            var buttons = chart_helper.getChartButtons();
            if (labels.length > 1) {
                var btnPoints = document.createElement("button");
                btnPoints.id = "btnPoints";
                btnPoints.innerHTML = '<i class="icon icon-askue_points"><svg class="svgicon-askue_points"><use xlink:href="/data/icons/svg#icon-askue_points"></use></svg></i>';
                btnPoints.style.cssText = "margin:2px; width:40px";
                btnPoints.classList.add("btn");
                btnPoints.classList.add("btn-primary");
                btnPoints.classList.add("btnchecked");
                btnPoints.title = "Скрыть точки";
                btnPoints.onclick = function () {
                    if (btnPoints.classList.contains("btnchecked")) {
                        btnPoints.classList.remove("btnchecked");
                        btnPoints.title = "Показать точки";
                    }
                    else {
                        btnPoints.classList.add("btnchecked");
                        btnPoints.title = "Скрыть точки";
                    }
                    for (var n = 0; n < sec.length; n++) {
                        var dots = d3.select("#dots" + n);
                        var dots_ = d3.select("#dots_" + n);
                        display_ic(n);
                        display_nc(n);
                        if (sec[n] && btnPoints.classList.contains("btnchecked")) {
                            dots.style("opacity", "1");
                            dots_.style("opacity", "1");
                        }
                        if (!btnPoints.classList.contains("btnchecked")) {
                            dots.style("opacity", "0");
                            dots_.style("opacity", "0");
                        }
                    }
                    return false;
                };
                buttons.appendChild(btnPoints);

                chart_helper.addButtonSave(document.getElementById("balanceps_contenttitle").innerText);
                d3.select("#chartRect1").attr("width", width + margin.left + margin.right);
                d3.select("#chartRect1").attr("height", height + margin.top + margin.bottom);
                d3.select("#chartRect2").remove();

                buttons.appendChild(document.createElement("br"));

                var btnScaleUp = document.createElement("button");
                btnScaleUp.id = "btnScaleUp";
                btnScaleUp.innerHTML = '+';
                btnScaleUp.style.cssText = "margin:2px; width:30px";
                btnScaleUp.classList.add("btn");
                btnScaleUp.classList.add("btn-primary");
                btnScaleUp.title = "Увеличить масштаб";
                btnScaleUp.onclick = function () {
                    zoom.scaleBy(svg.transition().duration(1000), 1.25);
                    return false;
                };
                buttons.appendChild(btnScaleUp);

                var btnScaleDown = document.createElement("button");
                btnScaleDown.id = "btnScaleDown";
                btnScaleDown.innerHTML = '-';
                btnScaleDown.style.cssText = "margin:2px; width:30px";
                btnScaleDown.classList.add("btn");
                btnScaleDown.classList.add("btn-primary");
                btnScaleDown.title = "Уменьшить масштаб";
                btnScaleDown.onclick = function () {
                    zoom.scaleBy(svg.transition().duration(1000), 0.8);
                    return false;
                };
                buttons.appendChild(btnScaleDown);

                var btnScaleReset = document.createElement("button");
                btnScaleReset.id = "btnScaleReset";
                btnScaleReset.innerHTML = '100%';
                btnScaleReset.style.cssText = "margin:2px; width:50px";
                btnScaleReset.classList.add("btn");
                btnScaleReset.classList.add("btn-primary");
                btnScaleReset.title = "Сброс масштаба";
                btnScaleReset.onclick = function () {
                    zoom.scaleTo(svg.transition().duration(1000), 1);
                    return false;
                };
                buttons.appendChild(btnScaleReset);

                var spanScale = document.createElement("span");
                spanScale.id = "spanScale";
                spanScale.innerHTML = 'Масштаб: 100%';
                spanScale.style.padding = "6px";
                buttons.appendChild(spanScale);

                //g2.on("click")();
            }
        }
    };

    return instance;
    
}();